import { InfoSheet } from './info-sheet';

export default InfoSheet;
